import { useMutation, useQueryCache } from "react-query";
import { useToasts } from "react-toast-notifications";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import {
  postNotifyNotificationContent,
  PostNotifyNotificationContentBody,
  PostNotifyNotificationContentResponse,
} from "../../../queries/notify";
import { buildNotifyInfiniteNotificationContentQueryKey } from "./useInfiniteNotificationContent";
import { ToastStatuses } from "../../../components/global_components/Toast";

export function useNotifyNotificationContentCreate({
  onSuccess = () => {},
  onError = () => {},
}: {
  onSuccess?: (notificationContent: PostNotifyNotificationContentResponse) => void | Promise<void>;
  onError?: () => void;
} = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();
  const { addToast } = useToasts();

  const [createNotificationContentMutation, { isLoading: isCreateNotificationContentLoading }] = useMutation(
    postNotifyNotificationContent(networkHeaders),
    {
      onSuccess: async (notificationContent) => {
        await queryCache.invalidateQueries(buildNotifyInfiniteNotificationContentQueryKey());
        onSuccess(notificationContent);
      },
      onError: () => {
        addToast("Failed to create notify content.", { appearance: ToastStatuses.Error, autoDismiss: true });
        onError();
      },
    },
  );

  const createNotificationContent = async (body: PostNotifyNotificationContentBody) => {
    return await createNotificationContentMutation(body);
  };

  return {
    createNotificationContent,
    isCreateNotificationContentLoading,
  };
}
